import { render, staticRenderFns } from "./SelectedLanguage.vue?vue&type=template&id=c5d5253a&scoped=true"
import script from "./SelectedLanguage.vue?vue&type=script&lang=js"
export * from "./SelectedLanguage.vue?vue&type=script&lang=js"
import style0 from "./SelectedLanguage.vue?vue&type=style&index=0&id=c5d5253a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d5253a",
  null
  
)

export default component.exports